
import Vue from 'vue';
import cloneDeep from 'clone-deep';
import {saveAs} from 'file-saver';

import * as Api from '@/api';

import { BLSearchResult } from '@/types/blacklabtypes';
import { debugLog } from '@/utils/debug';

export default Vue.extend({
	props: {
		results: Object as () => BLSearchResult,
		type: String as () => 'hits'|'docs',
		annotations: Array as () => string[],
		metadata: Array as () => string[],

		disabled: Boolean
	},
	data: () => ({
		downloadInProgress: false,
	}),
	methods: {
		downloadCsv(excel: boolean) {
			if (this.downloadInProgress || !this.results) {
				return;
			}

			this.downloadInProgress = true;
			const apiCall = this.type === 'hits' ? Api.blacklab.getHitsCsv : Api.blacklab.getDocsCsv;
			const params = cloneDeep(this.results.summary.searchParam);
			if (this.annotations) params.listvalues = this.annotations!.join(',');
			if (this.metadata) params.listmetadatavalues = this.metadata.join(',');
			(params as any).csvsepline = !!excel;
			(params as any).csvsummary = true;

			debugLog('starting csv download', this.type, params);
			apiCall(INDEX_ID, params).request
			.then(
				blob => saveAs(blob, 'data.csv'),
				error => debugLog('Error downloading csv file', error)
			)
			.finally(() => this.downloadInProgress = false);
		},
	}
})
